<template>
  <div class="flex flex-col h-screen">
    <div class="bg-white-light shadow px-5 py-3">
      <img src="@/assets/logo-red.svg" class="h-12" />
    </div> <!-- <header> -->

    <router-view class="flex-grow px-5" /> <!-- <content> -->

    <Footer /> <!-- <footer> -->
  </div>
</template>

<script>
import Footer from '@/components/layout/Footer.vue';

export default {
    name: 'blankLayout',
    props: {
        msg: String
    },
    components: {
        Footer
    }
};
</script>

<style lang="scss" scoped>
</style>
